import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "account-page" }
const _hoisted_2 = { class: "container account-page__inner" }
const _hoisted_3 = { class: "account-page__card" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "bi bi-person-fill account-page__avatar-icon"
}
const _hoisted_6 = { class: "account-page__avatars" }
const _hoisted_7 = {
  class: "account-page__avatars-grid",
  role: "listbox",
  "aria-label": "آواتارها"
}
const _hoisted_8 = ["aria-selected", "title", "disabled", "onClick"]
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { class: "account-page__username" }
const _hoisted_11 = { class: "account-page__username-row" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "account-page__details" }
const _hoisted_15 = { class: "account-page__row" }
const _hoisted_16 = { class: "account-page__row" }

import { computed, onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { updateMe } from "@/api/users";
import { useAuth } from "@/composables/useAuth";
import { COCO_AVATARS, resolveAvatarSrc } from "@/constants/avatars";
import { handleError } from "@/services/errorHandler";


export default /*@__PURE__*/_defineComponent({
  __name: 'Profile',
  setup(__props) {

const router = useRouter();
const { user, init, fetchCurrentUser } = useAuth();
const avatars = COCO_AVATARS;
const saving = ref(false);
const savingUsername = ref(false);
const usernameDraft = ref("");
const saveMessage = ref<string | null>(null);
const saveError = ref(false);

const usernameDirty = computed(() => {
  const current = typeof user.value?.username === "string" ? user.value.username : "";
  return usernameDraft.value.trim().toLowerCase() !== current.toLowerCase();
});

const selectedId = computed(() => {
  const value = user.value?.avatar_url;
  return typeof value === "string" ? value : null;
});

const avatarSrc = computed(() => resolveAvatarSrc(selectedId.value));

const initials = computed(() => {
  const name = user.value?.full_name?.trim();
  if (name) {
    const parts = name.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return name.slice(0, 2).toUpperCase();
  }
  const handle = typeof user.value?.username === "string" ? user.value.username : "";
  if (handle) return handle.slice(0, 2).toUpperCase();
  return "";
});

async function selectAvatar(id: string) {
  if (saving.value || selectedId.value === id) return;
  saving.value = true;
  saveMessage.value = null;
  saveError.value = false;
  try {
    await updateMe({ avatar_url: id });
    await fetchCurrentUser();
    saveMessage.value = "آواتار ذخیره شد.";
  } catch (e) {
    saveError.value = true;
    saveMessage.value = handleError(e, "Profile.selectAvatar");
  } finally {
    saving.value = false;
  }
}

async function saveUsername() {
  if (!usernameDirty.value || savingUsername.value) return;
  savingUsername.value = true;
  saveMessage.value = null;
  saveError.value = false;
  try {
    await updateMe({ username: usernameDraft.value.trim().toLowerCase() });
    await fetchCurrentUser();
    saveMessage.value = "نام کاربری ذخیره شد.";
  } catch (e) {
    saveError.value = true;
    saveMessage.value = handleError(e, "Profile.saveUsername");
  } finally {
    savingUsername.value = false;
  }
}

function goBack() {
  router.push("/dashboard");
}

onMounted(async () => {
  await init();
  await fetchCurrentUser();
});

watch(
  () => user.value?.username,
  (value) => {
    if (typeof value === "string") usernameDraft.value = value;
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "account-page__back",
        onClick: goBack
      }, [...(_cache[1] || (_cache[1] = [
        _createElementVNode("svg", {
          viewBox: "0 0 24 24",
          width: "20",
          height: "20",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "aria-hidden": "true"
        }, [
          _createElementVNode("path", {
            d: "M5 12H19",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }),
          _createElementVNode("path", {
            d: "M13 6l6 6-6 6",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          })
        ], -1),
        _createElementVNode("span", null, "بازگشت", -1)
      ]))]),
      _cache[9] || (_cache[9] = _createElementVNode("header", { class: "account-page__header" }, [
        _createElementVNode("p", { class: "account-page__eyebrow" }, "حساب کاربری"),
        _createElementVNode("h1", { class: "account-page__title" }, "پروفایل"),
        _createElementVNode("p", { class: "account-page__subtitle" }, "اطلاعات حساب و آواتار cocouni شما")
      ], -1)),
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["account-page__avatar", { 'account-page__avatar--image': !!avatarSrc.value }])
        }, [
          (avatarSrc.value)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: avatarSrc.value,
                alt: "آواتار",
                class: "account-page__avatar-img"
              }, null, 8, _hoisted_4))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (!initials.value)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_5))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(initials.value), 1)
                    ], 64))
              ], 64))
        ], 2),
        _createElementVNode("div", _hoisted_6, [
          _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "account-page__avatars-title" }, "انتخاب آواتار", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("p", { class: "account-page__avatars-hint" }, "یکی از نارگیل‌های cocouni رو برای پروفایلت انتخاب کن.", -1)),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(avatars), (avatar) => {
              return (_openBlock(), _createElementBlock("button", {
                key: avatar.id,
                type: "button",
                class: _normalizeClass(["account-page__avatar-option", { 'account-page__avatar-option--active': selectedId.value === avatar.id }]),
                "aria-selected": selectedId.value === avatar.id,
                title: avatar.label,
                disabled: saving.value,
                onClick: ($event: any) => (selectAvatar(avatar.id))
              }, [
                _createElementVNode("img", {
                  src: avatar.src,
                  alt: avatar.label
                }, null, 8, _hoisted_9)
              ], 10, _hoisted_8))
            }), 128))
          ]),
          (saveMessage.value)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                class: _normalizeClass(["account-page__save-msg", { 'is-error': saveError.value }])
              }, _toDisplayString(saveMessage.value), 3))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[5] || (_cache[5] = _createElementVNode("label", {
            class: "account-page__username-label",
            for: "username"
          }, "نام کاربری", -1)),
          _cache[6] || (_cache[6] = _createElementVNode("p", { class: "account-page__avatars-hint" }, "این نام در جامعه یادگیری و جدول امتیازات دیده می‌شود، نه شماره موبایل. ۳ تا ۲۴ کاراکتر، با حرف انگلیسی شروع شود.", -1)),
          _createElementVNode("div", _hoisted_11, [
            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "account-page__username-prefix" }, "@", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "username",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((usernameDraft).value = $event)),
              class: "account-page__username-input",
              maxlength: "24",
              spellcheck: "false",
              autocapitalize: "off",
              autocomplete: "username",
              placeholder: "coco_abc123",
              disabled: savingUsername.value
            }, null, 8, _hoisted_12), [
              [
                _vModelText,
                usernameDraft.value,
                void 0,
                { trim: true }
              ]
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "account-page__username-save",
              disabled: savingUsername.value || !usernameDirty.value,
              onClick: saveUsername
            }, _toDisplayString(savingUsername.value ? "..." : "ذخیره"), 9, _hoisted_13)
          ])
        ]),
        _createElementVNode("dl", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _cache[7] || (_cache[7] = _createElementVNode("dt", null, "نام کامل", -1)),
            _createElementVNode("dd", null, _toDisplayString(_unref(user)?.full_name || "—"), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[8] || (_cache[8] = _createElementVNode("dt", null, "شماره موبایل", -1)),
            _createElementVNode("dd", null, _toDisplayString(_unref(user)?.phone_number || "—"), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})